module.exports = __webpack_public_path__ + "img/index2.f77e685f.png";